import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module15Nav = () => {
  const { module15 } = useSelector((state) => state.module15, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module15Images/Unit3_Mod5_JourneyMap.png';
    const mobileImage =
      '/Module15Images/Unit3_Mod5_JourneyMap_phone_1.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(event.target),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module15Images/m15-BG-chromebook.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module10Images/Module10NavImages/JourneyMap_Mod5_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module10Images/Module10NavImages/JourneyMap_Mod5_Outline_Day${dayNumber}.png`;

    return {
      dayNumber,
      destiny: '/activelistening',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/active_listening/active_listening_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/close_affirmation.mp4`,
      `userfiles/${module15.StudentID}/active_listening_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid1}/close_affirmation.mp4`,
      `userfiles/${module15.StudentID}/active_listening_celebration_surprise_7.mp4`,
      `influencers/${login.influencerid2}/close_video_message.mp4`,
      `influencers/${login.influencerid3}/close_affirmation.mp4`,
      `userfiles/${module15.StudentID}/active_listening_celebration_surprise_9.mp4`,
      `influencers/${login.influencerid4}/close_affirmation.mp4`
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE15'
          module={module15}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit3'
          nextDestiny='/unit4'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={3}
          animal={MediaService.getImage('/Images/Button_BirdHead.png', login)}
        />
      )}
    </>
  );
};
export default Module15Nav;
